import React,{ useState,useEffect} from 'react'
import contactEditIcon from '../../../assets/images/contact-edit-icon.svg';
import contactDeleteIcon from '../../../assets/images/contact-delete-icon.svg';
import sliderCloseIcon from '../../../assets/images/slider-close-icon.svg';
import deletePopupIcon from '../../../assets/images/delete-popup-icon.svg';
import {useSelector,useDispatch} from 'react-redux'
import { fetchCustomMessages,updatecustomMessage,deleteCustomMessage } from '../../../redux/action';

export default function Templates() {
  const dispatch=useDispatch()
  const custommessages=useSelector((state)=>state.customMessages)
  const [selectedTemplate,setSelectedTemplate]=useState({
    id : false,
    name: "",
    text_message: ""
  }) 

  const clearState=()=>{
    setSelectedTemplate({
        id : false,
    name: "",
    text_message: ""
    })
  }

  const handleSubmit=()=>{
    if(selectedTemplate.name==="" && selectedTemplate.text_message===""){
        return
    }
    let form = new FormData()
    form.append('text_message', selectedTemplate.text_message) 
    form.append('name', selectedTemplate.name) 
    form.append('voice_message', "") 
    form.append('binary_files', "")
    form.append('message_type', 1)
    form.append('forward_type', 2)
    form.append('forward_date_time', null)
    form.append('is_active', 1)
    if( selectedTemplate.id ){
        dispatch(updatecustomMessage( form, selectedTemplate.id ));  
      }else{
        dispatch(updatecustomMessage( form ))
      }

  }

  const updateTextInput=( target )=>{
     
    selectedTemplate[ target.name ] = target.value
    setSelectedTemplate({...selectedTemplate})
  }

  const getCustomMessages=()=>{
    dispatch(fetchCustomMessages())
  }

  useEffect(()=>{
   getCustomMessages()
  },[])

  return (
    <>
    <div class="row mt-4">
                    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 main-section-scroll-height">
                        <div class="row pt-1">
                            <div class="col-md-6 col-lg-6 col-sm-12 co-xs-12">
                            </div>
                            <div class="col-md-6 col-lg-6 col-sm-12 co-xs-12">
                                <div class="d-flex justify-content-end align-items-center">
                                    <button class="secondary-btn" type="button" data-bs-toggle="offcanvas"
                                        data-bs-target="#createContactCanvas" aria-controls="createContactCanvas" onClick={()=>clearState()}>
                                        Add New
                                    </button>
                                </div>
                            </div>
                        </div>

                        <table class="mt-2 table table-borderless">
                            <thead>
                                <tr>
                                  {/*  <th class="align-middle" style={{width:'10%'}} scope="col">ID</th>*/}
                                    <th class="align-middle" style={{width:'20%'}} scope="col">Template Name</th>
                                    <th class="align-middle" style={{width:'60%'}} scope="col">Message</th>
                                    <th class="align-middle" style={{width:'10%'}} scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                              {custommessages && custommessages.templates && custommessages.templates.length>0 && custommessages.templates.map((template)=>(
                               <tr key={template.id}>
                               {/*<td class="align-middle"> ID#002</td>*/}
                               <td class="align-middle">{template.name}</td>
                               
                               <td class="align-middle">{template.text_message}</td>
                               <td class="align-middle">
                                   <button class="slider-close-btn me-1" type="button" onClick={()=>setSelectedTemplate(template)} data-bs-toggle="offcanvas"
                                       data-bs-target="#editContactCanvas" aria-controls="editContactCanvas">
                                       <img src={contactEditIcon} class="img-fluid"/>
                                   </button>
                                   <button class="slider-close-btn me-1" data-bs-toggle="modal" onClick={()=>setSelectedTemplate(template)}
                                       data-bs-target="#delteContact"><img
                                           src={contactDeleteIcon} class="img-fluid"/></button>
                               </td>
                           </tr> 
                              ))}
                                                              
                            </tbody>
                        </table>
                    </div>

                </div>
           {/*     <!--Create Contact Slider--> */}
    <div class="offcanvas offcanvas-end" tabIndex="-1" id="createContactCanvas"
        aria-labelledby="createContactCanvasLabel">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="createContactCanvasLabel">Add New Template</h5>
            <button type="button" class="slider-close-btn" data-bs-dismiss="offcanvas"><img
                    src={sliderCloseIcon} class="img-fluid"/></button>
        </div>
        <div class="offcanvas-body">
            
            <div class="mt-2">
             <input type="text" value={selectedTemplate.name} name='name' onChange = {e => { updateTextInput(e.target) }} class="form-control slider-inputs" placeholder="Title"/>
            </div>
            <div class="mt-2">
                <textarea name="text_message" value={selectedTemplate.text_message} onChange = {e => { updateTextInput(e.target) }} class="form-control slider-inputs text-area-height" placeholder="Message Body" aria-label="With textarea"></textarea>
            </div>
            <div class="d-flex justify-content-end mt-4">
                <button class="slider-cancel-btn me-2" data-bs-dismiss="offcanvas">Cancel</button>
                <button class="slider-success-btn" data-bs-dismiss="offcanvas" onClick={handleSubmit}>Add</button>
            </div>
        </div>
    </div>


  {/*  <!--Edit Contact Slider-->  */}
    <div class="offcanvas offcanvas-end" tabIndex="-1" id="editContactCanvas" aria-labelledby="editContactCanvasLabel">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="editContactCanvasLabel">Edit Template</h5>
            <button type="button" class="slider-close-btn" data-bs-dismiss="offcanvas"><img
                    src={sliderCloseIcon} class="img-fluid"/></button>
        </div>
        <div class="offcanvas-body">
            
            <div class="mt-2">
             <input type="text" onChange = {e => { updateTextInput(e.target) }} value={selectedTemplate.name} class="form-control slider-inputs" placeholder="title" 
             name="name"
             />
            </div>
            <div class="mt-5">
                <textarea onChange = {e => { updateTextInput(e.target) }} class="form-control slider-inputs text-area-height" placeholder="Message Body" aria-label="With textarea" name='text_message' value={selectedTemplate.text_message} ></textarea>
            </div>
            

            <div class="d-flex justify-content-end mt-4">
                <button class="slider-cancel-btn me-2" data-bs-dismiss="offcanvas">Cancel</button>
                <button class="slider-success-btn" data-bs-dismiss="offcanvas" onClick={handleSubmit}>Update</button>
            </div>
        </div>
    </div>



   {/* <!--Delete Contact Popup--> */}
    <div class="modal fade" id="delteContact" tabIndex="-1" aria-labelledby="delteContactLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="delteContactLabel">Delete Record</h5>
                    <button type="button" class="slider-close-btn" data-bs-dismiss="modal">
                        <img src={sliderCloseIcon} class="img-fluid"/>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="d-flex justify-content-center">
                        <img src={deletePopupIcon}/>
                    </div>
                    <div class="mt-4">
                        <p class="text-center">Do you really want to remove this record?</p>
                    </div>
                </div>
                <div class="d-flex justify-content-center mb-4">
                    <button class="slider-cancel-btn me-2" data-bs-dismiss="modal">Cancel</button>
                    <button class="slider-success-btn"  data-bs-dismiss="modal" onClick={()=>dispatch(deleteCustomMessage(selectedTemplate.id))}>Remove</button>
                </div>
            </div>
        </div>
    </div>
                </>
  )
}
